import React from 'react'
import HeaderSearch from './../components/HeaderSearch'
import TopSearches  from '../components/TopSearches'
 import ForWomen     from '../components/products/ForWomenProducts'
// import ForMen       from './formen'
// import ForKids      from './forkids'

const Search = () => {
  return (
    // Full-screen white overlay
    <div className="fixed inset-0 bg-white z-50 overflow-auto">
      {/* Fixed header */}
      <HeaderSearch />

      {/* Push content below header */}
      <div className="pt-14">
        {/* Top Searches section */}
        <div className="px-4 py-3">
          <TopSearches />
        </div>

        {/* For Women section */}
        <div className="px-4 py-3">
          <ForWomen />
         
        </div>

        {/* For Men section */}
        <div className="px-4 py-3">
          {/* <ForMen /> */}
          For Men
        </div>

        {/* For Kids section */}
        <div className="px-4 py-3 pb-6">
          {/* <ForKids /> */}
          For Kids
        </div>
      </div>
    </div>
  )
}

export default Search
